export const LOAD_OFFER_PAYMENT_PLAN_SUCCESS = 'LOAD_OFFER_PAYMENT_PLAN_SUCCESS';
export const LOAD_OFFER_PAYMENT_PLAN_STARTED = 'LOAD_OFFER_PAYMENT_PLAN_STARTED';
export const LOAD_OFFER_PAYMENT_PLAN_FAILED = 'LOAD_OFFER_PAYMENT_PLAN_FAILED';

export const LOAD_OFFER_PAYMENT_PLAN_SUMMARY_SUCCESS = 'LOAD_OFFER_PAYMENT_PLAN_SUMMARY_SUCCESS';
export const LOAD_OFFER_PAYMENT_PLAN_SUMMARY_STARTED = 'LOAD_OFFER_PAYMENT_PLAN_SUMMARY_STARTED';
export const LOAD_OFFER_PAYMENT_PLAN_SUMMARY_FAILED = 'LOAD_OFFER_PAYMENT_PLAN_FAILED';

export const LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS = 'LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS';
export const LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED = 'LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED';
export const LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED = 'LOAD_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED';

export const LOAD_SCHEDULE_PARAMS_TYPE_SUCCESS = 'LOAD_SCHEDULE_PARAMS_TYPE_SUCCESS';

export const LOAD_DOCUMENT_SCHEDULE_PARAMS_STARTED = 'LOAD_DOCUMENT_SCHEDULE_PARAMS_STARTED';
export const LOAD_DOCUMENT_SCHEDULE_PARAMS_SUCCESS = 'LOAD_DOCUMENT_SCHEDULE_PARAMS_SUCCESS';
export const LOAD_DOCUMENT_SCHEDULE_PARAMS_FAILED = 'LOAD_DOCUMENT_SCHEDULE_PARAMS_FAILED';

export const SAVE_DOCUMENT_SCHEDULE_PARAMS_SUCCESS = 'SAVE_DOCUMENT_SCHEDULE_PARAMS_SUCCESS';
export const SAVE_DOCUMENT_SCHEDULE_PARAMS_STARTED = 'SAVE_DOCUMENT_SCHEDULE_PARAMS_STARTED';
export const SAVE_DOCUMENT_SCHEDULE_PARAMS_FAILED = 'SAVE_DOCUMENT_SCHEDULE_PARAMS_FAILED';

export const DOCUMENT_SCHEDULE_PARAMS_INVALIDATED = 'DOCUMENT_SCHEDULE_PARAMS_INVALIDATED';

export const SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED = 'SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_STARTED';
export const SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED = 'SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_FAILED';
export const SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS = 'SAVE_DOCUMENT_SCHEDULE_CELL_PARAMS_SUCCESS';

export const LOAD_OFFER_ADVANCE_SPLIT_SUCCESS = 'LOAD_OFFER_ADVANCE_SPLIT_SUCCESS';
export const LOAD_OFFER_ADVANCE_SPLIT_STARTED = 'LOAD_OFFER_ADVANCE_SPLIT_STARTED';
export const LOAD_OFFER_ADVANCE_SPLIT_FAILED = 'LOAD_OFFER_ADVANCE_SPLIT_FAILED';
export const SAVE_OFFER_ADVANCE_SPLIT_SUCCESS = 'SAVE_OFFER_ADVANCE_SPLIT_SUCCESS';
export const SAVE_OFFER_ADVANCE_SPLIT_FAILED = 'SAVE_OFFER_ADVANCE_SPLIT_FAILED';
export const SAVE_OFFER_ADVANCE_SPLIT_STARTED = 'SAVE_OFFER_ADVANCE_SPLIT_STARTED';

export const IMPORT_PAYMENT_PLAN_STARTED = 'IMPORT_PAYMENT_PLAN_STARTED';
export const IMPORT_PAYMENT_PLAN_SUCCESS = 'IMPORT_PAYMENT_PLAN_SUCCESS';
export const IMPORT_PAYMENT_PLAN_FAILED = 'IMPORT_PAYMENT_PLAN_FAILED';

export const LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_STARTED = 'LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_STARTED';
export const LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_SUCCESS = 'LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_SUCCESS';
export const LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATES_FAILED = 'LOAD_SCHEDULE_TYPE_CELL_PARAM_TEMPLATE_FAILED';

export const GENERATE_INVOICE_STARTED = 'GENERATE_INVOICE_STARTED';
export const GENERATE_INVOICE_SUCCESS = 'GENERATE_INVOICE_SUCCESS';
export const GENERATE_INVOICE_FAILED = 'GENERATE_INVOICE_SUCCESS';
